import { RadioButtonOption } from "../../../common/enums";

export const CLOSED_SPACE_CHECKLIST_VERSION_2026_02 = 1;

export type ClosedSpaceChecklist = {
    checklistVersion: number | undefined;
    areAllTermsMet: RadioButtonOption;
    isThereARescuePlan: RadioButtonOption;
    isManHoleGuardAvailable: RadioButtonOption;
    areGasMeasurementsPerformed: RadioButtonOption;
    areWarningSignsOnManholes: RadioButtonOption;
    isLightningSufficient: RadioButtonOption;
    isThereEmergencyEquipment: RadioButtonOption;
    areGasMeasurementsPerformedInClosedSpace: RadioButtonOption;
    isPersonalAtEntryToClosedSpace: RadioButtonOption;
    isMechanicalVentilation: RadioButtonOption;
    hasRescueHarness: RadioButtonOption;
    willThereBeRescuePlan: RadioButtonOption;
    willYouHaveARescueHarness: RadioButtonOption;
    willThereBeEmergencyEquipment: RadioButtonOption;
    isTrainedManHoleGuardAvailable: RadioButtonOption;
    isOtherPersonnelAtEntry: RadioButtonOption;
    willGasMeasurementsBePerformedAndDocumented: RadioButtonOption;
    areWarningSignsOnOpenings: RadioButtonOption;
};

